module.exports = __webpack_public_path__ + "static/media/CleverTap_fav-removebg-preview.d5e8d5c0.png";